import supabaseClient from '@/api/supabaseClient.ts';
import { ItineraryRepository } from '$/repositories/itineraryRepository/ItineraryRepository.ts';

const itineraryRepository = new ItineraryRepository(supabaseClient);
export default itineraryRepository;

